import { ImageName } from "@mcleod/images";
import { EditRowDecoratorBehavior, MultiButton } from "@mcleod/components";

export class AppEditRowDecoratorBehavior extends EditRowDecoratorBehavior {
    protected constructor() {
        super();
    }

    public addSaveButton(decorator: any, saveAndAddFunc: Function, saveAndCloseFunc: Function): void {
        if (decorator.onSave != null) {
            decorator.multiButton = new MultiButton({
                themeKey: "editRowDecorator.multiButton",
                id: "erdMultiButton",
                rowBreak: false,
                ...decorator.saveButtonProps
            });

            decorator.multiButton.primaryButton.setProps({
                themeKey: "editRowDecorator.primaryButton",
                id: "erdButtonSaveClose",
                caption: null,
                imageName: ImageName.send,
                default: true,
                width: "unset",
                height: "unset",
                imageWidth: 24,
                imageHeight: 24,
                fontSize: "medium",
                backgroundColor: "transparent",
                fillRow: false
            });

            decorator.multiButton.primaryButton.addClickListener(() => saveAndCloseFunc());
            decorator.panelHeader.add(decorator.multiButton.primaryButton);
        }
    }
}

AppEditRowDecoratorBehavior.register();
